export default __webpack_public_path__ + "static/media/mbanner.2cf3566a.jpg";